var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('v-btn',{staticClass:"clear-filter-btn",attrs:{"text":"","height":"30"},on:{"click":function($event){return _vm.clickHandler()}}},[_vm._v(" Clear filters ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }